import { Base64 } from "js-base64";

// Universities with different total steps
const universities = [
  {
    university: "iimv",
    total_steps: 5,
  },
  {
    university: "iimt",
    total_steps: 5,
  },
  {
    university: "iitg",
    total_steps: 6,
  },
  {
    university: "xlri",
    total_steps: 4,
  },
  {
    university: "spjain",
    total_steps: 5,
  },
  {
    university: "iith",
    total_steps: 5,
  },
  {
    university: "iiml",
    total_steps: 5,
  },
  {
    university: "iim-ranchi",
    total_steps: 5,
  },
  {
    university: "iim-amritsar",
    total_steps: 5,
  },
  {
    university: "iit-jammu",
    total_steps: 5,
  },
  {
    university: "iim-kashipur",
    total_steps: 5,
  },
  {
    university: "unknown",
    total_steps: 1,
  },
];

// Function to get total steps for a university
export const getTotalSteps = (university) => {
  const uni = universities.find((u) => u.university === university);
  return uni ? uni.total_steps : 1; // Fallback to 1 to prevent division by zero
};

export function formatDate(dateString) {
  // Convert the date string to a Date object
  const date = new Date(dateString);

  // Format date to "12 September 2024" in Indian time zone
  const formattedDate = new Intl.DateTimeFormat("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  }).format(date);

  return formattedDate;
}

// Function to group applications based on their completion status
export const groupApplicationsByStatus = (applications, categories) => {
  const groupedData = {
    ongoing: [],
    completed: [],
  };

  applications.forEach((app) => {
    // Add vertical label from categories
    const categoryData = categories.find((cat) =>
      cat.category.includes(app.category)
    );
    app.vertical = categoryData?.label || "Unknown";

    const totalSteps = getTotalSteps(app.university);

    // Custom logic:
    // If step is exactly the total and status is complete => completed
    if ((app.step === totalSteps && app.step_status === "complete") || (['xlri', 'iitk'].includes(app.university) && app.step_status === "complete")) {
      groupedData.completed.push(app);
    } else {
      groupedData.ongoing.push(app);
    }
  });

  return groupedData;
};


export const encodeBase64 = (base64String) => {
  try {
    let encodedString = Base64.encode(base64String);

    return encodedString;
  } catch (e) {
    console.log("error", e);
    return null;
  }
};

export const paymentPortalRedirectionURL = (university, application_id) => {
  const updatedUniversity = university === 'iimt' ? "iim-trichy" : university
  const url =
    process.env.REACT_APP_NODE_ENV === "development"
      ? `http://localhost:5173`
      : `https://${updatedUniversity}.accredian.com`;

  return `${url}/?app_id=${encodeBase64(application_id)}`;
}

export const generateApiKey = () => {
  // 🔐 Generate secure timestamp key
  const secretKey = process.env.REACT_APP_AUTH_SHARED_SECRET
  const randomKey = Math.random().toString(36).substring(2, 12)
  const timestamp = Date.now().toString()
  const rawKey = `${secretKey}:${randomKey}:${timestamp}`
  console.log("Raw Key:", rawKey);
  const encodedKey = btoa(rawKey) // Base64 encode
  return encodedKey;
}
  ;
